export default {
  'invitation.language': 'Language',
  'invitation.templateName': 'Template Name',
  'invitation.operator': 'Operate',
  'invitation.operationTime': 'Operate Time',
  'invitation.operation': 'Operate',
  'invitation.edit': 'Time',
  'invitation.invitee': 'Invitee',
  'invitation.join': 'Join',
  'invitation.jinbiaos': 'Tournament Reward',
  'invitation.peopleInviterGetsReward1': 'Invitee gets reward',
  'invitation.Reward': 'Reward',
  'invitation.modify': 'Edit',
  'invitation.tickets': 'Tickets',
  'invitation.invitationRewardMode': 'Invitation Reward Mode',
  'invitation.ladderMode': 'Ladder Mode',
  'invitation.ladderConfig': 'Ladder Config',
  'invitation.addLadder': 'Add Ladder',
  'invitation.ladder': 'Laddar',
  'invitation.totalInvitations': 'Total invitation reaches',
  'invitation.mustBeGreaterThanLadder': "Invitee number must be higher than {index}'s laddar",
  'invitation.peopleInviterGets': 'pax, User receive',
  'invitation.ticketsReward': 'Ticket',
  'invitation.afterCompletingAllLadders': 'Once completed all laddar, every',
  'invitation.peopleInviterGetsReward': 'pax, User receive',
  'invitation.ticketsRewardFinal': 'Ticket',
  'invitation.label.ticket': 'Ticket Amount',
  'invitation.label.bonus': 'Bonus',
  'invitation.validator.twoElectOne': 'Either Tickets or Bonus must be filled out',
  'invitation.inviteeKycRequired': 'Inviter gets the reward after the invitee completes KYC',
};
